import i18n from "i18next";
import backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import { Constants } from "@zanichelli/myz-react-utils";

i18n
  .use(backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: "it",
    fallbackLng: ["it"],
    keySeparator: "",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      // for all available options read the backend’s repository readme file
      loadPath: `${Constants.ENV.S3_URL}/{{ns}}/translations/it.json`,
      // allow cross domain requests
      crossDomain: true,
      // allow credentials on cross domain requests
      withCredentials: false,
    },
    ns: ["myz", "wotd", "dashboard"],
    defaultNS: "wotd",
    // react: {
    //   wait: true,
    //   useSuspense: false,
    // },
  });

export default i18n;
